import { create } from 'zustand';
import { apiService } from '../services/api';

export interface Category {
  id: string;
  displayName: string;
  description: string;
  icon: string;
}

interface CategoriesState {
  // Data
  categories: Category[];
  
  // Loading state
  isLoading: boolean;
  
  // Error state
  error: string | null;
  
  // Prevent duplicate fetches
  hasLoaded: boolean;
  
  // Actions
  fetchCategories: () => Promise<void>;
  getCategoryById: (id: string) => Category | null;
}

export const useCategoriesStore = create<CategoriesState>((set, get) => ({
  // Initial state
  categories: [],
  isLoading: false,
  error: null,
  hasLoaded: false,
  
  // Fetch categories from API
  fetchCategories: async () => {
    // Don't fetch if already loaded or currently loading
    const state = get();
    if (state.hasLoaded || state.isLoading) {
      return;
    }
    
    set({ isLoading: true, error: null });
    
    try {
      const response = await apiService.get('/categories');
      
      if (response.data.success && response.data.data) {
        set({ 
          categories: response.data.data,
          isLoading: false,
          hasLoaded: true,
          error: null
        });
        console.log('✅ Loaded categories:', response.data.data.length);
      } else {
        throw new Error('Invalid response format');
      }
    } catch (error: any) {
      console.error('Failed to fetch categories:', error);
      set({ 
        error: error.message || 'Failed to load categories',
        isLoading: false,
        hasLoaded: false
      });
    }
  },
  
  // Helper to get category by ID
  getCategoryById: (id: string) => {
    const state = get();
    return state.categories.find(cat => cat.id === id) || null;
  }
}));

